import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "c-app flex-row align-items-center" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row justify-content-center" }
const _hoisted_4 = { class: "col-md-4" }
const _hoisted_5 = { class: "card-group" }
const _hoisted_6 = { class: "card p-4" }
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = /*#__PURE__*/_createVNode("h1", null, "Login", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("p", { class: "text-muted" }, "Sign In to your account", -1)
const _hoisted_10 = {
  key: 0,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_11 = { class: "input-group mb-3" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createVNode("span", { class: "input-group-text" }, [
    /*#__PURE__*/_createVNode("svg", { class: "c-icon" }, [
      /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-user" })
    ])
  ])
], -1)
const _hoisted_13 = { class: "input-group mb-4" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createVNode("span", { class: "input-group-text" }, [
    /*#__PURE__*/_createVNode("svg", { class: "c-icon" }, [
      /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-lock-locked" })
    ])
  ])
], -1)
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SubmitButton = _resolveComponent("SubmitButton")
  const _component_Splash = _resolveComponent("Splash")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode("form", {
                  onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["prevent"]))
                }, [
                  _hoisted_8,
                  _hoisted_9,
                  (_ctx.errorMessage)
                    ? (_openBlock(), _createBlock("div", _hoisted_10, _toDisplayString(_ctx.errorMessage), 1))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _withDirectives(_createVNode("input", {
                      class: "form-control",
                      type: "text",
                      placeholder: "Email",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.email = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.email]
                    ])
                  ]),
                  _createVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _withDirectives(_createVNode("input", {
                      class: "form-control",
                      type: "password",
                      placeholder: "Password",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.password = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.password]
                    ])
                  ]),
                  _createVNode("div", _hoisted_15, [
                    _createVNode("div", _hoisted_16, [
                      _createVNode(_component_SubmitButton, {
                        text: "Login",
                        loadingText: " Login...",
                        isSubmitting: _ctx.isSubmitting
                      }, null, 8, ["isSubmitting"])
                    ])
                  ])
                ], 32)
              ])
            ]),
            (_ctx.loaded)
              ? (_openBlock(), _createBlock(_component_Splash, { key: 0 }))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}